<template>
    <button
        type="button"
        class="gap-x-2 rounded-lg px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm focus-visible:outline-indigo-600 inline-flex items-center bg-[#26272B] hover:opacity-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
    >
        <slot></slot>
    </button>
</template>

<script setup lang="ts"></script>
